import axios from "axios";
import { useCurrentLocaleSelector as getCurrentLocaleSelector } from '../utils/localisation';
import { getBearerToken } from "../auth";

export const getCurrentOwnersLocaleSelector = () => {
  const defaultLocaleForApp = 'en-US';
  const systemLocale = localStorage.getItem('ownersLocale') ?? defaultLocaleForApp;
  let selectedLocale = systemLocale;
  const ownersLocale = localStorage.getItem('ownersLocale');
  if (ownersLocale) {
    selectedLocale = JSON.parse(ownersLocale);
  } else {
    selectedLocale = defaultLocaleForApp;
  }

  return selectedLocale || systemLocale;
};

export const isUKOwnershipLocale = (locale) => locale ? locale === "en-GB" : getCurrentOwnersLocaleSelector === "en-GB";

export const getCurrentUserEmail = () => {
  const profile = localStorage.getItem('kinship_web_profile');
  let profileEmail = "systemLocale";
  console.log(profile)
  if (profile) {
    profileEmail = JSON.parse(profile)?.email;
  }
  return profileEmail;
};

export const getCurrentUserKinshipId = () => {
  try {
    const raw = localStorage.getItem("kinship_web_profile");
    if (!raw) return null;

    const profile = JSON.parse(raw);
    return profile?.kinship_user_id ?? null;
  } catch {
    return null;
  }
};


const attachBearerTokenInterceptor = (instance) => {
  instance.interceptors.request.use(async (config) => {
    const token = await getBearerToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
};

export const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Kinship-Source': 'Kinship',
    'apikey': `${process.env.REACT_APP_KINSHIP_API_KEY}`,
    'Accept-Language': getCurrentLocaleSelector(),
    'X-KI-Requester-Email': getCurrentUserEmail(),
  },
  mode: 'no-cors',
  crossdomain: true,
  baseURL: `https://${process.env.REACT_APP_KINSHIP_API_BASE_URL}`,
  timeout: 20000,
});

attachBearerTokenInterceptor(api);

export const apiOwner = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Kinship-Source': 'Kinship',
    'apikey': `${process.env.REACT_APP_KINSHIP_API_KEY}`,
    'Accept-Language': getCurrentOwnersLocaleSelector(),
    'X-KI-Requester-Email': getCurrentUserEmail()
  },
  mode: 'no-cors',
  crossdomain: true,
  baseURL: `https://${process.env.REACT_APP_KINSHIP_API_BASE_URL}`,
  timeout: 20000,
});

attachBearerTokenInterceptor(apiOwner);

export const baas = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Kinship-Source': 'Kinship',
    'apikey': `${process.env.REACT_APP_KINSHIP_API_KEY}`,
    'Accept-Language': getCurrentLocaleSelector(),
    'X-KI-Requester-Email': getCurrentUserEmail()
  },
  mode: 'no-cors',
  crossdomain: true,
  baseURL: `https://${process.env.REACT_APP_KINSHIP_API_BASE_URL}/baas`,
  timeout: 20000,
});

attachBearerTokenInterceptor(baas);

export const baasOwner = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Kinship-Source': 'Kinship',
    'apikey': `${process.env.REACT_APP_KINSHIP_API_KEY}`,
    'Accept-Language': getCurrentOwnersLocaleSelector(),
    'X-KI-Requester-Email': getCurrentUserEmail()
  },
  mode: 'no-cors',
  crossdomain: true,
  baseURL: `https://${process.env.REACT_APP_KINSHIP_API_BASE_URL}/baas`,
  timeout: 20000,
});

attachBearerTokenInterceptor(baasOwner);

export const apiNoTokenAWS = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Kinship-Source': 'Kinship',
    'apikey': `${process.env.REACT_APP_KINSHIP_API_KEY}`,
    'Accept-Language': getCurrentLocaleSelector(),
    'X-KI-Requester-Email': getCurrentUserEmail(),
  },
  mode: 'no-cors',
  crossdomain: true,
  baseURL: `https://${process.env.REACT_APP_KINSHIP_API_BASE_URL}`,
  timeout: 20000,
});

export const externalAPICall = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Kinship-Source': 'Kinship',
    'Accept-Language': getCurrentOwnersLocaleSelector(),
    'X-KI-Requester-Email': getCurrentUserEmail()
  },
  mode: 'no-cors',
  crossdomain: true,
  timeout: 20000,
});
